import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import LandingPage from "./pages/landingPage";
import AboutPage from "./pages/aboutPage";
import ServicePage from "./pages/servicePage";
import ApproachPage from "./pages/approachPage";
import FeesPage from "./pages/feesPage";
import ContactPage from "./pages/contactPage";
import PrivacyPage from "./pages/privacyPage";
import FaqPage from "./pages/faqPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route index element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/approach" element={<ApproachPage />} />
          <Route path="/fees" element={<FeesPage />} /> 
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
